import logo from "../../../../public/projects/Brigade/images/logo/logo.png";
import calista from "../../../../public/projects/Brigade/images/projects/Calista.jpg";
import Oasis from "../../../../public/projects/Brigade/images/projects/Oasis.jpg";
import insignia from "../../../../public/projects/Brigade/images/projects/Insignia.jpg";
import horizon from "../../../../public/projects/Brigade/images/projects/Horizon.jpg";

//insignia
import overviewImage_insignia from "../../../../public/projects/Brigade/images/insignia/Overview/1.webp";
import bannerDesktopImage_insignia from "../../../../public/projects/Brigade/images/insignia/Banner/1.webp";
import bannerMobileImage_insignia from "../../../../public/projects/Brigade/images/insignia/Banner/2.webp";
import siteVisitBannerImage_insignia from "../../../../public/projects/Brigade/images/insignia/SiteVisitBanner/1.webp";
import Location_insignia from "../../../../public/projects/Brigade/images/insignia/Location/L1.webp";
import Hightlights_insignia from "../../../../public/projects/Brigade/images/insignia/Highlights/1.webp";
import image1BHK_insignia from "../../../../public/projects/Brigade/images/insignia/floorplan/1.webp";
import image2BHK_insignia from "../../../../public/projects/Brigade/images/insignia/floorplan/2.webp";
import image3BHK_insignia from "../../../../public/projects/Brigade/images/insignia/floorplan/3.webp";
import location_insignia from "../../../../public/projects/Brigade/images/insignia/Overview/l.png";
import cal_insignia from "../../../../public/projects/Brigade/images/insignia/Overview/c.png";
import newlaunch_insignia from "../../../../public/projects/Brigade/images/insignia/Overview/n.png";
import g1_insignia from "../../../../public/projects/Brigade/images/insignia/Gallery/1.webp";
import g2_insignia from "../../../../public/projects/Brigade/images/insignia/Gallery/2.webp";
import g3_insignia from "../../../../public/projects/Brigade/images/insignia/Gallery/3.webp";
import g4_insignia from "../../../../public/projects/Brigade/images/insignia/Gallery/4.webp";
import g5_insignia from "../../../../public/projects/Brigade/images/insignia/Gallery/5.webp";

//horizon
import overviewImage_horizon from "../../../../public/projects/Brigade/images/horizon/Overview/1.webp";
import bannerDesktopImage_horizon from "../../../../public/projects/Brigade/images/horizon/Banner/1.webp";
import bannerMobileImage_horizon from "../../../../public/projects/Brigade/images/horizon/Banner/2.webp";
import siteVisitBannerImage_horizon from "../../../../public/projects/Brigade/images/horizon/SiteVisitBanner/1.webp";
import Location_horizon from "../../../../public/projects/Brigade/images/horizon/Location/L1.webp";
import Hightlights_horizon from "../../../../public/projects/Brigade/images/horizon/Highlights/1.webp";
import image1BHK_horizon from "../../../../public/projects/Brigade/images/horizon/floorplan/1.webp";
import image2BHK_horizon from "../../../../public/projects/Brigade/images/horizon/floorplan/2.webp";
import image3BHK_horizon from "../../../../public/projects/Brigade/images/horizon/floorplan/3.webp";
import location_horizon from "../../../../public/projects/Brigade/images/horizon/Overview/l.png";
import cal_horizon from "../../../../public/projects/Brigade/images/horizon/Overview/c.png";
import newlaunch_horizon from "../../../../public/projects/Brigade/images/horizon/Overview/n.png";
import g1_horizon from "../../../../public/projects/Brigade/images/horizon/Gallery/1.webp";
import g2_horizon from "../../../../public/projects/Brigade/images/horizon/Gallery/2.webp";
import g3_horizon from "../../../../public/projects/Brigade/images/horizon/Gallery/3.webp";
import g4_horizon from "../../../../public/projects/Brigade/images/horizon/Gallery/4.webp";
import g5_horizon from "../../../../public/projects/Brigade/images/horizon/Gallery/5.webp";

// pashmina
import overviewImagepashmina from "../../../../public/projects/brigade/pashmina/overview/1.webp";
import bannerDesktopImagepashmina from "../../../../public/projects/brigade/pashmina/banner/1.webp";
import bannerMobileImagepashmina from "../../../../public/projects/brigade/pashmina/banner/2.webp";
import Locationpashmina from "../../../../public/projects/brigade/pashmina/location/1.webp";
import Hightlightspashmina from "../../../../public/projects/brigade/pashmina/highlights/1.webp";
import floorplan1pashmina from "../../../../public/projects/brigade/pashmina/floorplan/1.webp";
import floorplan2pashmina from "../../../../public/projects/brigade/pashmina/floorplan/2.webp";
import floorplan3pashmina from "../../../../public/projects/brigade/pashmina/floorplan/3.webp";
import floorplan4pashmina from "../../../../public/projects/brigade/pashmina/floorplan/4.webp";
import floorplan5pashmina from "../../../../public/projects/brigade/pashmina/floorplan/5.webp";
import locationiconpashmina from "../../../../public/projects/brigade/pashmina/overview/l.png";
import caliconpashmina from "../../../../public/projects/brigade/pashmina/overview/c.png";
import newlaunchiconpashmina from "../../../../public/projects/brigade/pashmina/overview/n.png";
import gallery1pashmina from "../../../../public/projects/brigade/pashmina/gallery/1.webp";
import gallery2pashmina from "../../../../public/projects/brigade/pashmina/gallery/2.webp";
import gallery3pashmina from "../../../../public/projects/brigade/pashmina/gallery/3.webp";
import gallery4pashmina from "../../../../public/projects/brigade/pashmina/gallery/4.webp";
import gallery5pashmina from "../../../../public/projects/brigade/pashmina/gallery/5.webp";


export const developersBrigade = {
  name: `Brigade  Properties in Bengaluru `,
  properties: [
    {
      name: "Brigade Insignia",
      image: insignia,
      price: "On Request",
      location: "Yelahanka, Bengaluru",
      bed: "2 - 5 BHK Apartments",
      state: "Bengaluru",
      developer: "Brigade",
      size: "1386 - 090 sq. ft.",
      url: `/brigade-insignia-yelahanka-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Brigade  Horizon",
      image: horizon,
      price: "On Request",
      location: "Mysore Road, Bengaluru",
      projectlocation: "Mysore Road",
      state: "Bengaluru",
      developer: "Brigade",
      bed: "2 - 3 BHK Apartments",
      size: "1013 - 1064 sq. ft.",
      url: `/brigade-horizon-kumbalgodu-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Brigade Pashmina",
      image: bannerDesktopImagepashmina,
      price: "On Request",
      location: "Tumkur Road, Bangalore",
      projectlocation: "Tumkur Road, Bangalore",
      state: "Bengaluru",
      developer: "Brigade",
      bed: "2 - 3 BHK Apartments",
      size: "On Request",
      url: `/brigade-pashmina`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1986",
  },
  about: `Brigade has built prominent developments across many sectors since 1986, and has chance to witness India's real estate evolution. We have done residential, commercial, hospitality, and retail projects which are maintained with a high level of quality and excellence. Our clients consider these developments to be of great class and style. Our unwavering commitment to continuously overcome customer expectations has always proving our motto to be true.`,
};
export const projectsbrigade = {
  insignia: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_insignia,
      bannerMobileImage: bannerMobileImage_insignia,
      textOverlay: "",
      data: {
        title: "Brigade Insignia",
        subtitle: "Yelahanka, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/180524/006894",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Brigade Insignia",
      description: [
        `At Brigade Insignia, your residence becomes your unique personal brand. Set on 6 acres of untouched land, this collection of beautiful homes serves as a canvas filled with light and air. Located directly on the airport highway and with metro access, Brigade Insignia effortlessly connects you to the heartbeat of the city. However, it maintains a peaceful and charming atmosphere, surrounded by verdant gardens that provide a retreat from the fast-paced urban life. You'll find yourself close to one of Asia's largest malls, Manyata Tech Park, Manipal Hospital, Outer Ring Road (ORR), Yelahanka New Town, and Kempegowda International Airport (KIA).

Brigade Insignia feels like a treasured locale, featuring elegant residences and a timeless rooftop space perfect for small gatherings. Daylight invites a playful interaction of light and air here, while evenings bring with them the soothing melodies of starry nights.



`,
      ],
      image: overviewImage_insignia,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_insignia,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_insignia,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_insignia,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_insignia,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2.5 BHK",
          area: "1386  sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1677 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3.5 BHK",
          area: "1415 sq. ft. - 1724 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2066 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "3090 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2.5 BHK",
        area: "1386  sq. ft.",
        price: "On Request",
        image: image1BHK_insignia,
      },
      {
        type: "3 BHK",
        area: "1677 sq. ft.",
        price: "On Request",
        image: image2BHK_insignia,
      },
      {
        type: "3.5 BHK",
        area: "1415 sq. ft. - 1724 sq. ft.",
        price: "On Request",
        image: image3BHK_insignia,
      },

      {
        type: "4 BHK",
        area: "2066 sq. ft.",
        price: "On Request",
        image: image2BHK_insignia,
      },
      {
        type: "5 BHK",
        area: "3090 sq. ft.",
        price: "On Request",
        image: image3BHK_insignia,
      },
    ],

    highlights: {
      images: Hightlights_insignia,
      tagline: "Highlights",
      features: [
        "Elegantly designed 1094 Superior and Elite apartments spread across a 14.9-acre landscape.",
        "MNear Manyata Tech Park.",
        "Carefully organized basement parking ensuring a 100% vehicle-free environment.",
        "An opulent 31,000 sq.ft clubhouse offering luxurious facilities like a spa, salt room, unisex salon, and hanging Zen garden.",
        "Brigade Insignia Yelahanka housing society has 6 towers with 15 floors.",
      ],
    },

    location: {
      image: Location_insignia,
      data: [
        {
          airport: {
            distance_time: "19 Km",
            name: "Bengaluru Airport",
          },
          school: {
            distance_time: "6.5 Km",
            name: "Reva University",
          },
          railwayormetro: {
            distance_time: "2 Km",
            name: "Yelahanka Junction",
          },
          hospital: {
            distance_time: "7.4 Km",
            name: "Manipal Hospital",
          },
          mall: {
            distance_time: "2.6 Km",
            name: "The Galleria Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_insignia },
        { image: g2_insignia },
        { image: g3_insignia },
        { image: g4_insignia },
        { image: g5_insignia },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Brigade Insignia, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Brigade - Oasis Phase 3",
          image: Oasis,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Wellesley Road",
          state: "Bengaluru",
          developer: "Brigade",
          bed: "1 - 3 BR Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Brigade - Calista Phase 2",
          image: calista,
          price: "On Request",
          location: "Bengaluru",
          projectlocation:
            "Devanahalli Airport Road, Bommenahalli village, Bengaluru,",
          state: "Bengaluru",
          developer: "Brigade",
          bed: "2 - 3 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Brigade - Horizon",
          image: horizon,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Mysore Road",
          state: "Bengaluru",
          developer: "Brigade",
          bed: "2 - 3 BHK Apartments",
          size: "On Request",
          url: `/brigade-horizon-kumbalgodu-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  horizon: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_horizon,
      bannerMobileImage: bannerMobileImage_horizon,
      textOverlay: "",
      data: {
        title: "Brigade Horizon",
        subtitle: "Mysore Road, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/190722/005086",
        payment_plan: "",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Brigade Horizon",
      description: [
        `Brigade Horizon is a newly launched residential apartment project situated on Mysore Road, close to Kengeri and Kumbalgodu in West Bengaluru. 

This residential community, Horizon, showcases the finest in Brigade Group’s premium living offerings. The project features spacious 1, 2, and 3 BHK apartments with luxurious amenities. 

Featuring beautiful landscapes, ample greenery, and over 60% open spaces, Horizon by Brigade adds to its uniqueness and exclusivity. 

The developer is dedicated to providing a high-quality living experience for the Mysore Road community in West Bengaluru, characterized by impressive architecture and a corresponding lifestyle at Horizon. 

Brigade Horizon is ideally located with excellent connectivity at the heart of Mysore Road in Kambipura, near Kumbalgodu, Kengeri, Rajarajeshwari Colleges, as well as various existing and upcoming communities and facilities. 

Amenities at Brigade Horizon include a fully equipped clubhouse, landscaped gardens, a gym, a swimming pool, recreation rooms, outdoor sports courts, a children's play area, a party hall, and meticulously designed features that emphasize state-of-the-art 24/7 security.
`,
      ],
      image: overviewImage_horizon,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_horizon,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_horizon,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_horizon,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_horizon,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "1013 - 1064 sq. ft.",
          price: "On Request",
        },
        {
          type: "3 BHK",
          area: "1064  sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "1013 - 1064 sq. ft.",
        price: "On Request",
        image: image1BHK_horizon,
      },
      {
        type: "3 BHK",
        area: "1064  sq. ft",
        price: "On Request",
        image: image2BHK_horizon,
      },
    ],

    highlights: {
      images: Hightlights_horizon,
      tagline: "Highlights",
      features: [
        "Incorporates rainwater harvesting to promote environmentally friendly water conservation practices.",
        "Facilities include a sun deck, multipurpose hall, library, spa, and party lawn, catering to a variety of needs and preferences.",
        "Provides amenities such as a cricket pitch, tennis court, swimming pool, badminton court, and jogging track, encouraging an active and healthy lifestyle.",
        "Marigold International School is situated at a distance of 3.1 km.",
        "SDM Institute of Ayurveda & Hospital can be found 3.7 km away.",
      ],
    },

    location: {
      image: Location_horizon,
      data: [
        {
          airport: {
            distance_time: "53.1 Km",
            name: "KIA",
          },
          school: {
            distance_time: "3.3 Km",
            name: "Christ Kengeri ",
          },
          railwayormetro: {
            distance_time: "11.3 Km",
            name: "Jnanabharati Station",
          },
          hospital: {
            distance_time: "10.6 Km",
            name: " Bengaluru Hospital",
          },
          mall: {
            distance_time: "12.1 Km",
            name: "Gopalan Arcade ",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_horizon },
        { image: g2_horizon },
        { image: g3_horizon },
        { image: g4_horizon },
        { image: g5_horizon },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Brigade Horizon, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Brigade - Insignia",
          image: insignia,
          price: "On Request",
          location: "Yelahanka, Bengaluru",
          bed: "1 - 3 BHK",
          state: "Bengaluru",
          developer: "Brigade",
          size: "....",
          url: `/brigade-insignia-yelahanka-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Brigade - Oasis Phase 3",
          image: Oasis,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Wellesley Road",
          state: "Bengaluru",
          developer: "Brigade",
          bed: "1 - 3 BR Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Brigade - Calista Phase 2",
          image: calista,
          price: "On Request",
          location: "Bengaluru",
          projectlocation:
            "Devanahalli Airport Road, Bommenahalli village, Bengaluru,",
          state: "Bengaluru",
          developer: "Brigade",
          bed: "2 - 3 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  pashmina: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagepashmina,
      bannerMobileImage: bannerMobileImagepashmina,
      textOverlay: "",
      data: {
        title: "Brigade Pashmina Tumkur Road Bangalore",
        subtitle: "Tumkur Road, Bangalore",
        starting_price: "On Request    ",
        payment_plan: "CLP",
        rerano: "Coming Soon",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Brigade Pashmina Tumkur Road Bangalore",
      description: [
        "Brigade Pashmina Tumkur Road Bangalore is an upcoming residential project by the renowned Brigade Group, offering a blend of luxury, comfort, and strategic connectivity in one of Bangalore’s fastest-growing locales. Spanning 8 acres of lush green landscape, this premium development features meticulously designed 2 and 3 BHK apartments that cater to the modern lifestyle needs of families and professionals alike. Each apartment is crafted to maximize natural light, ventilation, and space utilization, ensuring a serene and elegant living environment for residents13. The project’s location on Tumkur Road is a major advantage, providing excellent connectivity to key areas of Bangalore via NH4, Outer Ring Road, and the nearby Namma Metro station. Its proximity to major employment hubs like Peenya Industrial Area and Manyata Tech Park, as well as reputed schools, hospitals, shopping centers, and entertainment zones, makes it an ideal choice for homebuyers seeking convenience and growth potential12.",
        "Residents of Brigade Pashmina Tumkur Road will enjoy a host of world-class amenities, including a modern clubhouse, swimming pools for adults and children, a fully equipped gym, landscaped gardens, children’s play areas, sports courts, and a multipurpose hall. Enhanced security features such as 24/7 surveillance and power backup ensure a safe and hassle-free lifestyle13. The project is also designed with sustainability in mind, incorporating eco-friendly initiatives like rainwater harvesting and energy-efficient systems to promote green living2. Backed by the Brigade Group’s legacy of quality construction and innovative design, Brigade Pashmina Tumkur Road Bangalore stands out as a smart investment opportunity, promising high returns and a luxurious living experience in a rapidly developing neighborhood.",
      ],
      keywordLinks: {

      },
      image: overviewImagepashmina,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconpashmina,
          title: " On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconpashmina,
          title: "New Launch",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconpashmina,
          title: "Under Construction",
          subtitle: " Status",
        },
      ],
    },



    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: " On Request ",
          price: " On Request ",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: " On Request ",
          price: " On Request ",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: " On Request ",
        price: " On Request ",
        image: floorplan1pashmina,
      },
      {
        type: "3 BHK",
        area: " On Request ",
        price: " On Request ",
        image: floorplan2pashmina,
      },


    ],

    highlights: {
      images: Hightlightspashmina,
      tagline: "Highlights",
      features: [
        "Backup power for water pumps, elevators, fire safety systems, and lighting in common areas. ",
        "CCTV monitoring at the entrance lobby, elevators, and parking entry and exit points.",
        "Attractive floor lobbies. ",
        "Landscaped garden on the terrace. ",
        "Located at Hosur Road - Kudlu Gate",
        "Swimming pool and gym located on the terrace level. ",
      ],
    },

    location: {
      image: Locationpashmina,
      data: [
        {
          airport: {
            distance_time: "37 km",
            name: "Kempegowda International Airport",
          },
          school: {
            distance_time: "5.5 Km",
            name: "Cluny Convent High School",
          },
          railwayormetro: {
            distance_time: "800 m",
            name: "Kudlu Gate Metro (Upcoming)",
          },
          hospital: {
            distance_time: "7.5 Km",
            name: "Sapthagiri Hospital",
          },
          mall: {
            distance_time: "9 Km",
            name: "Orion Mall, Rajajinagar",
          },
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1pashmina },
        { image: gallery2pashmina },
        { image: gallery3pashmina },
        { image: gallery4pashmina },
        { image: gallery5pashmina },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Brigade Pashmina Tumkur Road, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Brigade Pashmina located in Bangalore?",
        answer: "Brigade Pashmina is strategically located on Tumkur Road, one of the fastest-growing corridors in Northwest Bangalore.",
      },
      {
        question: "What types of apartments are available at Brigade Pashmina?",
        answer: "The project offers a range of 2 BHK and 3 BHK apartments designed with contemporary architecture, optimal space utilization, and premium finishes.",
      },
      {
        question: "What are the key amenities in Brigade Pashmina Tumkur Road Bangalore?",
        answer: "Brigade Pashmina features a host of modern amenities including a clubhouse, swimming pool, gymnasium, and landscaped gardens.",
      },
      {
        question: "Who is the developer of Brigade Pashmina?",
        answer: "Brigade Pashmina is developed by Brigade Group.",
      },
      {
        question: "What is the price range of apartments in Brigade Pashmina Tumkur Road?",
        answer: "The price of apartments in Brigade Pashmina Tumkur Road is not disclosed yet.",
      },
      {
        question: "How is the connectivity of Brigade Pashmina Tumkur Road Bangalore?",
        answer: "The project enjoys excellent connectivity via Tumkur Road, Yeswanthpur Railway Station, and Peenya Industrial Area.",
      },
      {
        question: "Are there good schools and hospitals near Brigade Pashmina?",
        answer: "Yes, reputed institutions like Orchids The International School, Narayana Nethralaya, and Columbia Asia Hospital are located nearby.",
      },
      {
        question: "What makes Brigade Pashmina a good investment?",
        answer: "Brigade Pashmina offers a blend of strategic location, trusted brand, and modern amenities, making it a sound investment choice.",
      },
      {
        question: "How can I book an apartment in Brigade Pashmina Tumkur Road?",
        answer: "You can book your apartment by contacting our sales team.",
      },
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
